import React, { Children } from 'react';
import { StarIcon, ShieldCheckIcon } from 'lucide-react';
export function PrivacyPolicyPage() {
  return <div className="min-h-screen w-full bg-[#f8f7f4] font-sans text-[#1e293b]" data-id="element-1386">
      {/* Top Nav Bar */}
      <header className="bg-[#002868] text-white w-full" data-id="element-1387">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 h-12 flex items-center justify-between" data-id="element-1388">
          <a href="/" className="flex items-center gap-2 font-bold text-lg tracking-tight" data-id="element-1389">
            <StarIcon className="w-5 h-5 fill-current text-[#b91c1c]" data-id="element-1390" />
            <span data-id="element-1391">PatriotsInformer</span>
          </a>
        </div>
      </header>

      <div className="bg-white border-b border-gray-200 w-full" data-id="element-1392"></div>

      {/* Main Content */}
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16" data-id="element-1393">
        {/* Page Header */}
        <div className="mb-10 space-y-3" data-id="element-1394">
          <div className="flex items-center gap-2 text-[#b91c1c]" data-id="element-1395">
            <ShieldCheckIcon className="w-6 h-6" data-id="element-1396" />
            <span className="text-sm font-bold uppercase tracking-widest text-[#64748b]" data-id="element-1397">
              Legal
            </span>
          </div>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-[#0f172a] tracking-tight leading-tight" data-id="element-1398">
            Privacy Policy
          </h1>
          <p className="text-[#64748b] text-sm" data-id="element-1399">Last Updated: February 2026</p>
          <div className="h-1 w-16 bg-[#b91c1c] rounded" data-id="element-1400"></div>
        </div>

        {/* Policy Content */}
        <div className="space-y-10 text-[#334155] leading-relaxed" data-id="element-1401">
          <section className="space-y-3" data-id="element-1402">
            <p data-id="element-1403">
              PatriotsInformer Media, LLC ("we," "us," or "our") is committed to
              protecting your privacy. This Privacy Policy explains how we
              collect, use, disclose, and safeguard your information when you
              visit our website{' '}
              <strong className="text-[#0f172a]" data-id="element-1404">PatriotsInformer.com</strong>{' '}
              and any related pages or services. Please read this policy
              carefully. If you disagree with its terms, please discontinue use
              of the site.
            </p>
          </section>

          <section className="space-y-3" data-id="element-1405">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1406">
              1. Information We Collect
            </h2>
            <p data-id="element-1407">
              We may collect information about you in a variety of ways. The
              information we may collect includes:
            </p>
            <h3 className="font-semibold text-[#0f172a]" data-id="element-1408">Personal Data</h3>
            <p data-id="element-1409">
              When you voluntarily submit information through our opt-in forms,
              we may collect personally identifiable information such as your
              name and email address. You are under no obligation to provide us
              with personal information of any kind; however, your refusal to do
              so may prevent you from using certain features of the site.
            </p>
            <h3 className="font-semibold text-[#0f172a]" data-id="element-1410">Derivative Data</h3>
            <p data-id="element-1411">
              Our servers may automatically collect non-personal information
              when you access the site, such as your IP address, browser type,
              operating system, access times, and the pages you have viewed
              directly before and after accessing the site.
            </p>
            <h3 className="font-semibold text-[#0f172a]" data-id="element-1412">
              Cookies and Tracking Technologies
            </h3>
            <p data-id="element-1413">
              We may use cookies, web beacons, tracking pixels, and other
              tracking technologies on the site to help customize the site and
              improve your experience. You can instruct your browser to refuse
              all cookies or to indicate when a cookie is being sent. However,
              if you do not accept cookies, you may not be able to use some
              portions of our site.
            </p>
          </section>

          <section className="space-y-3" data-id="element-1414">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1415">
              2. How We Use Your Information
            </h2>
            <p data-id="element-1416">
              Having accurate information about you permits us to provide you
              with a smooth, efficient, and customized experience. Specifically,
              we may use information collected about you to:
            </p>
            <ul className="list-disc list-inside space-y-2 pl-2" data-id="element-1417">
              <li data-id="element-1418">Send you the content, guides, or resources you requested.</li>
              <li data-id="element-1419">
                Send you newsletters, updates, and promotional communications
                (with your consent).
              </li>
              <li data-id="element-1420">Improve our website, products, and services.</li>
              <li data-id="element-1421">
                Monitor and analyze usage and trends to improve your experience.
              </li>
              <li data-id="element-1422">
                Respond to your comments, questions, and customer service
                requests.
              </li>
              <li data-id="element-1423">Comply with applicable legal obligations.</li>
              <li data-id="element-1424">
                Prevent fraudulent transactions and monitor against theft.
              </li>
            </ul>
          </section>

          <section className="space-y-3" data-id="element-1425">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1426">
              3. Email Communications
            </h2>
            <p data-id="element-1427">
              By providing your email address through our opt-in forms, you
              consent to receive email communications from PatriotsInformer
              Media, LLC. These may include newsletters, survival tips, product
              recommendations, and promotional offers.
            </p>
            <p data-id="element-1428">
              You can unsubscribe from our email list at any time by clicking
              the "unsubscribe" link at the bottom of any email we send. Please
              note that you may continue to receive transactional or
              account-related emails even after unsubscribing from promotional
              communications.
            </p>
          </section>

          <section className="space-y-3" data-id="element-1429">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1430">
              4. Disclosure of Your Information
            </h2>
            <p data-id="element-1431">
              We do not sell, trade, or rent your personal information to third
              parties for their marketing purposes. We may share information we
              have collected about you in certain situations:
            </p>
            <h3 className="font-semibold text-[#0f172a]" data-id="element-1432">Service Providers</h3>
            <p data-id="element-1433">
              We may share your information with third-party vendors and service
              providers that perform services on our behalf, such as email
              delivery (AWeber), analytics, and hosting. These parties are
              contractually obligated to keep your information confidential and
              use it only to provide services to us.
            </p>
            <h3 className="font-semibold text-[#0f172a]" data-id="element-1434">Legal Requirements</h3>
            <p data-id="element-1435">
              We may disclose your information where required to do so by law or
              in response to valid requests by public authorities (e.g., a court
              or government agency).
            </p>
            <h3 className="font-semibold text-[#0f172a]" data-id="element-1436">Business Transfers</h3>
            <p data-id="element-1437">
              If we are involved in a merger, acquisition, or sale of all or a
              portion of our assets, your information may be transferred as part
              of that transaction.
            </p>
          </section>

          <section className="space-y-3" data-id="element-1438">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1439">
              5. Data Security
            </h2>
            <p data-id="element-1440">
              We implement administrative, technical, and physical security
              measures to help protect your personal information. While we have
              taken reasonable steps to secure the personal information you
              provide to us, please be aware that no security measures are
              perfect or impenetrable, and no method of data transmission can be
              guaranteed against any interception or other type of misuse.
            </p>
          </section>

          <section className="space-y-3" data-id="element-1441">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1442">
              6. Third-Party Websites
            </h2>
            <p data-id="element-1443">
              Our site may contain links to third-party websites and services.
              These third-party sites have separate and independent privacy
              policies. We have no responsibility or liability for the content
              and activities of these linked sites. Nonetheless, we seek to
              protect the integrity of our site and welcome any feedback about
              these sites.
            </p>
          </section>

          <section className="space-y-3" data-id="element-1444">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1445">
              7. Children's Privacy
            </h2>
            <p data-id="element-1446">
              Our website is not directed to children under the age of 13. We do
              not knowingly collect personal information from children under 13.
              If you are a parent or guardian and believe your child has
              provided us with personal information, please contact us so that
              we can delete such information.
            </p>
          </section>

          <section className="space-y-3" data-id="element-1447">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1448">
              8. Your Rights and Choices
            </h2>
            <p data-id="element-1449">
              Depending on your location, you may have certain rights regarding
              your personal information:
            </p>
            <ul className="list-disc list-inside space-y-2 pl-2" data-id="element-1450">
              <li data-id="element-1451">
                <strong data-id="element-1452">Access:</strong> You may request a copy of the personal
                information we hold about you.
              </li>
              <li data-id="element-1453">
                <strong data-id="element-1454">Correction:</strong> You may request that we correct
                inaccurate or incomplete information.
              </li>
              <li data-id="element-1455">
                <strong data-id="element-1456">Deletion:</strong> You may request that we delete your
                personal information, subject to certain exceptions.
              </li>
              <li data-id="element-1457">
                <strong data-id="element-1458">Opt-Out:</strong> You may opt out of receiving marketing
                emails at any time via the unsubscribe link.
              </li>
            </ul>
            <p data-id="element-1459">
              To exercise any of these rights, please contact us using the
              information provided below.
            </p>
          </section>

          <section className="space-y-3" data-id="element-1460">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1461">
              9. Changes to This Privacy Policy
            </h2>
            <p data-id="element-1462">
              We may update this Privacy Policy from time to time. We will
              notify you of any changes by updating the "Last Updated" date at
              the top of this page. You are encouraged to review this Privacy
              Policy periodically to stay informed of updates. Your continued
              use of the site after any changes constitutes your acceptance of
              the new Privacy Policy.
            </p>
          </section>

          <section className="space-y-3" data-id="element-1463">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1464">10. Contact Us</h2>
            <p data-id="element-1465">
              If you have questions or comments about this Privacy Policy,
              please contact us at:
            </p>
            <div className="bg-white border border-[#e2e8f0] rounded-lg p-6 space-y-2 shadow-sm" data-id="element-1466">
              <p className="font-bold text-[#0f172a]" data-id="element-1467">
                PatriotsInformer Media, LLC
              </p>
              <p data-id="element-1468">
                10160 Highway 242 Ste 800
                <br data-id="element-1469" />
                PMB 1089
                <br data-id="element-1470" />
                Conroe, TX 77385
              </p>
              <p data-id="element-1471">
                <span className="font-semibold text-[#0f172a]" data-id="element-1472">Email: </span>
                <a href="mailto:support@patriotsinformer.com" className="text-[#002868] underline" data-id="element-1473">
                  support@patriotsinformer.com
                </a>
              </p>
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 mt-12 py-12" data-id="element-1474">
        <div className="max-w-4xl mx-auto px-4 text-center space-y-4" data-id="element-1475">
          <div className="flex items-center justify-center gap-2" data-id="element-1476">
            <div className="relative w-10 h-10" data-id="element-1477">
              <StarIcon className="w-10 h-10 fill-current text-[#002868]" data-id="element-1478" />
              <StarIcon className="w-4 h-4 fill-current text-white absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" data-id="element-1479" />
            </div>
          </div>
          <div className="text-xs text-gray-500 space-y-2 max-w-2xl mx-auto leading-relaxed" data-id="element-1480">
            <p data-id="element-1481">
              © 2018-2026 PatriotsInformer Media, LLC | All Rights Reserved |
              63 N. Burritt - Buffalo, WY 82834 United States
            </p>
            <p className="space-x-2" data-id="element-1482">
              <a href="/privacy-policy" className="underline hover:text-[#002868]" data-id="element-1483">
                Privacy Policy
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>;
}